import * as Yup from 'yup';

export const getSchema = () => {
  return Yup.object().shape({
    location: Yup.mixed().required('This field is required!'),
    shift_type: Yup.mixed().required('This field is required!'),
    program: Yup.mixed().required('This field is required!'),
  });
};
